import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 25000,
});

// Attach JWT from localStorage + site-internal marker on every request
api.interceptors.request.use((config) => {
  const tok = localStorage.getItem("loft_token");
  config.headers = config.headers || {};
  // Mark same-origin site traffic so the backend can distinguish it from
  // scraper-friendly public JSON access. Not a security boundary; a marker.
  config.headers["X-Site-Client"] = "loft-web";
  if (tok) {
    config.headers.Authorization = `Bearer ${tok}`;
  }
  return config;
});

// Auto-logout on 401
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const tok = localStorage.getItem("loft_token");
      if (tok && !err.config?.url?.includes("/auth/login") && !err.config?.url?.includes("/auth/register")) {
        localStorage.removeItem("loft_token");
        // Soft reload to reset auth state if on a protected page
      }
    }
    return Promise.reject(err);
  }
);

export const fetchNews = (params) => api.get("/_site/portal/news", { params }).then((r) => r.data);
export const fetchTrending = (params) => api.get("/_site/portal/news/trending", { params }).then((r) => r.data);
export const fetchNewsById = (id) => api.get(`/_site/portal/news/${id}`).then((r) => r.data);
export const fetchPlans = () => api.get("/marketplace/plans").then((r) => r.data);
export const requestApiKey = (payload) => api.post("/marketplace/request-key", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
// Creem payment endpoints (server-side checkout, no client secrets)
export const createCreemCheckout = (amount) => api.post("/payments/checkout", { amount }).then((r) => r.data);
export const createCreemSubscription = (plan) => api.post(`/payments/subscribe/${plan}`).then((r) => r.data);
export const fetchMyTransactions = () => api.get("/users/me/transactions").then((r) => r.data);

// -------- Faz 4: user-owned API keys (hash-stored) --------
export const listMyApiKeys = () => api.get("/users/me/api-keys").then((r) => r.data);
export const createMyApiKey = (payload) => api.post("/users/me/api-keys", payload).then((r) => r.data);
export const rotateMyApiKey = (id) => api.post(`/users/me/api-keys/${id}/rotate`).then((r) => r.data);
export const revokeMyApiKey = (id) => api.post(`/users/me/api-keys/${id}/revoke`).then((r) => r.data);
export const deleteMyApiKey = (id) => api.delete(`/users/me/api-keys/${id}`).then((r) => r.data);
